// src/components/FixedBottomButton.tsx
import React from 'react';
import PrimaryButton from './PrimaryButton';

interface FixedBottomButtonProps {
  text: string;
  onClick: () => void;
  disable?: boolean;
}

const FixedBottomButton: React.FC<FixedBottomButtonProps> = ({ text, onClick, disable }) => {
  return (
    <div className="fixed bottom-[8px] left-1/2 w-[calc(100%-16px)] -translate-x-1/2 transform">
      <PrimaryButton text={text} onClick={onClick} disable={disable} />
    </div>
  );
};

export default FixedBottomButton;
